import { OBJECTIVE_ACQUISITION_STATUS } from "@academy-context/read/domain/types/training-follow-up";

interface ObjectiveStatusConfig {
  value: OBJECTIVE_ACQUISITION_STATUS;
  label: string;
  selectedClassName: string;
  unselectedClassName: string;
}

export const OBJECTIVE_STATUS_CONFIG: ObjectiveStatusConfig[] = [
  {
    value: OBJECTIVE_ACQUISITION_STATUS.ACQUIRED,
    label: "Acquis",
    selectedClassName: "bg-green-500 text-white border-green-500 hover:bg-green-500 active:bg-green-500",
    unselectedClassName:
      "border-green-500 text-green-600 bg-background hover:bg-green-50 active:bg-green-100 dark:text-green-400 dark:hover:bg-green-950 dark:active:bg-green-900",
  },
  {
    value: OBJECTIVE_ACQUISITION_STATUS.IN_PROGRESS,
    label: "En cours",
    selectedClassName: "bg-amber-500 text-white border-amber-500 hover:bg-amber-500 active:bg-amber-500",
    unselectedClassName:
      "border-amber-500 text-amber-600 bg-background hover:bg-amber-50 active:bg-amber-100 dark:text-amber-400 dark:hover:bg-amber-950 dark:active:bg-amber-900",
  },
  {
    value: OBJECTIVE_ACQUISITION_STATUS.NOT_ACQUIRED,
    label: "Non acquis",
    selectedClassName: "bg-red-500 text-white border-red-500 hover:bg-red-500 active:bg-red-500",
    unselectedClassName:
      "border-red-500 text-red-500 bg-background hover:bg-red-50 active:bg-red-100 dark:text-red-400 dark:hover:bg-red-950 dark:active:bg-red-900",
  },
];

export const getObjectiveStatusConfig = (status: OBJECTIVE_ACQUISITION_STATUS): ObjectiveStatusConfig => {
  const config = OBJECTIVE_STATUS_CONFIG.find(c => c.value === status);
  if (!config) throw new Error(`Unknown status: ${status}`);
  return config;
};
